
export const LOGIN_REQUEST = "LOGIN_REQUEST"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAILURE = "LOGIN_FAILURE"

export const REGISTER_REQUEST = "REGISTER_REQUEST"
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"
export const REGISTER_FAILURE = "REGISTER_FAILURE"

export const LOGOUT = "LOGOUT"

export const SELECT_CONVERSATION = "SELECT_CONVERSATION"
export const CLEAR_SELECT_CONVERSATION = "CLEAR_SELECT_CONVERSATION"
export const CONVERSATION_RECEIVED_MESSAGE = "CONVERSATION_RECEIVED_MESSAGE"

export const ON_NEW_CONVERSATION = "ON_NEW_CONVERSATION"
export const ON_UPD_CONVERSATION = "ON_UPD_CONVERSATION"

export const FETCH_CONVERSATION_REQUEST = "FETCH_CONVERSATION_REQUEST"
export const FETCH_CONVERSATION_SUCCESS = "FETCH_CONVERSATION_SUCCESS"
export const FETCH_CONVERSATION_FAILURE = "FETCH_CONVERSATION_FAILURE"

export const FETCH_CURRENT_MESSAGES_REQUEST = "FETCH_CURRENT_MESSAGES_REQUEST"
export const FETCH_CURRENT_MESSAGES_SUCCESS = "FETCH_CURRENT_MESSAGES_SUCCESS"
export const FETCH_CURRENT_MESSAGES_FAILURE = "FETCH_CURRENT_MESSAGES_FAILURE"

export const START_CONVERSATION_REQUEST = "START_CONVERSATION_REQUEST"
export const START_CONVERSATION_SUCCESS = "START_CONVERSATION_SUCCESS"
export const START_CONVERSATION_FAILURE = "START_CONVERSATION_FAILURE"


export const SOCKET_REQUEST = "SOCKET_REQUEST"
export const SOCKET_CONNECT = "SOCKET_CONNECT"
export const SOCKET_FAILURE = "SOCKET_FAILURE"

